export const fetchInstrumentsList = async () => {
    return fetch(`${process.env.API_URL}/cotizaciones/instrumentos/`)
        .then((response) => response.json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchInstrumentByCode = async (code) => {
    return fetch(`${process.env.API_URL}/cotizaciones/instrumento/${code}/`)
        .then((response) => response.json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchPaneles = async () => {
    return fetch(`${process.env.API_URL}/cotizaciones/home/paneles/`)
        .then((response) => response.json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchIndices = async () => {
    return fetch(`${process.env.API_URL}/cotizaciones/home/indices/`)
        .then((response) => response.json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchCotizaciones = async () => {
    return fetch(`${process.env.API_URL}/cotizaciones/home/cotizaciones_moneda/`)
        .then((response) => response.json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchProductos = async (locale) => {
    return fetch(`${process.env.API_URL}/cotizaciones/home/productos/?l=${locale}`)
        .then((response) => response.json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchRankings = async () => {
    return fetch(`${process.env.API_URL}/cotizaciones/home/rankings/`)
        .then((response) => response.json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchRankingByCode = async (code) => {
    return fetch(`${process.env.API_URL}/cotizaciones/ranking/${code}/`)
        .then((response) => response.json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchSearchItems = async () => {
    return fetch(`${process.env.API_URL}/cotizaciones/buscador/`)
        .then((response) => response.json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchInstrumentoDetail = async ({ type, symbol }) => {
    return fetch(`${process.env.API_URL}/cotizaciones/instrumento/${type}/?simbolo=${symbol}`)
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            return response.json();
        })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchFondoDetail = async (code) => {
    return fetch(`${process.env.API_URL}/cotizaciones/fondo/${code}/`)
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchDataIntradiariaInstrumento = async (code) => {
    return fetch(`${process.env.API_URL}/cotizaciones/intradiario/${code}/`)
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchMarketStatus = async (code) => {
    return fetch(`${process.env.API_URL}/cotizaciones/estado_mercado/`)
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchFondos = async () => {
    return fetch(`${process.env.API_URL}/cotizaciones/instrumento/fondos/`)
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            return response.json();
        })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchFondoById = async (id) => {
    return fetch(`${process.env.API_URL}/cotizaciones/fondo/${id}/`)
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            return response.json();
        })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const fetchResumenHistorico = async (codeA = "", codeB = "", codeC = "") => {
    return fetch(`${process.env.API_URL}/cotizaciones/resumen_historico/${codeA},${codeB},${codeC}`)
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            return response.json();
        })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log(error);
        });
};
